import { bound } from "@frui.ts/helpers";
import { Router } from "@frui.ts/screens";
import { Modules } from "config";
import CountryResponse from "entities/countryResponse";
import EnumRepository from "repositories/enumRepository";
import ConfirmationService from "services/confirmationService";
import EventBus from "services/eventBus";
import LocalizationService from "services/localizationService";
import NotificationService from "services/notificationService";
import SecurityService from "services/securityService";
import IncludeDeletedPaginatedRequest from "entities/includeDeletedPaginatedRequest";
import CountryCreateViewModel from "./countryCreateViewModel";
import CountryDetailViewModel from "./countryDetailViewModel";
import ListViewModel from "viewModels/listViewModel";

const navigationName = "countries";

@Router.registerRoute({ name: Router.Self, route: navigationName, children: [CountryCreateViewModel, CountryDetailViewModel] })
export default class CountriesViewModel extends ListViewModel<
  CountryResponse,
  CountryDetailViewModel,
  CountryCreateViewModel,
  IncludeDeletedPaginatedRequest
> {
  readonly modelName = "country";

  @bound
  allowItemDetail(item: CountryResponse) {
    return !item.isDeleted;
  }

  @bound
  allowItemDelete(item: CountryResponse) {
    return !item.isDeleted;
  }

  constructor(
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected notificationService: NotificationService,
    protected confirmationService: ConfirmationService,
    protected repository: EnumRepository,
    protected securityService: SecurityService,
    protected createViewModelFactory: () => CountryCreateViewModel,
    protected detailViewModelFactory: ReturnType<typeof CountryDetailViewModel.Factory>
  ) {
    super();
    this.navigationName = navigationName;
  }

  protected createFilter(): IncludeDeletedPaginatedRequest {
    return new IncludeDeletedPaginatedRequest();
  }

  protected fetchData() {
    const { limit, offset } = this.pagingFilter;
    return this.repository.getAllCountries({ ...this.appliedFilter, limit, offset });
  }

  delete(item: CountryResponse): any {
    return this.repository.delete(item, "countries", "1.2");
  }

  translate(code: string, size?: number): string {
    return this.localizationService.translateModule(Modules.timeCharges, `countries.${code}`, size);
  }
}
